import { createFileRoute } from '@tanstack/react-router';

import { AuthMobileView } from 'views/AuthMobileView';

type Search = {
  redirect?: string;
};

export const Route = createFileRoute('/_auth/auth-mobile')({
  component: AuthMobileView,
  validateSearch: (search) => {
    const output = { ...search };

    return output as Search;
  },
});
